<template>
  <div id="app">
    <component :is="layout"></component>
  </div>
</template>

<script>
import MainLayout from '@/layouts/MainLayout.vue'
import EmptyLayout from '@/layouts/EmptyLayout.vue'

import '@/scss/_reset.scss'
import '@/scss/fonts/_font.scss'
import '@/scss/_main.scss'

export default {
  name: 'App',
  components: { MainLayout, EmptyLayout },
  computed: {
    layout() {
      const layout = this.$route.meta.layout || 'Main'
      return `${layout}Layout`
    }
  }
}
</script>
